import React, { useState } from "react"
import { usePaletteTheme } from "../../context/paletteTheme"
import DatasetDropdown from './DatasetDropdown'
import { ThemeProvider } from 'styled-components'
import { MenuItem } from '@mui/material'
import MenuBar from '../ui/menuBar/MenuBar'
import ContainerDataTable from '../data-table/ContainerDataTable'
import PopoverMenu from '../ui/menuPopover/MenuPopover'
import { mainGraphLineColors as datasetColors } from '../../utils/constants'
import { useDataset } from "../../context/dataset"
import DiscoverModal from "../discover/components/DiscoverModal"
import { InfoOutlined, SignalCellularAltTwoTone, DeleteOutlined, Add } from '@mui/icons-material'
import * as DropDown from "./Datasets.style"

export default function DatasetButton({dataset, ticker, index, openKpiEditor, kpiEditorIndex, isKpiOpen, kpi_unselected}) {
    const [menuAnchorEl, setMenuAnchorEl] = useState(null)
    const [discoverModal, setDiscoverModal] = useState(false)
    const [anchorEl, setAnchorEl] = useState(null)
    const [openDataTable, setOpenDataTable] = useState(false)
    const { currentDataset, removeDataset, changeColumn, changeDataset, datasets, columns } = useDataset()
    const { colors } = usePaletteTheme()

    const inactive = !(dataset?.length + 1 > index)

    const datasetProps = { changeColumn, changeDataset, datasets } 

    const handleRemoveData = (e) => {
        e.stopPropagation()
        setAnchorEl(null)
        removeDataset()
    }

    const handleOpenKpiEditor = (e) => {
        e.stopPropagation()
        openKpiEditor(index)
        setAnchorEl(null)
    }

    const handleOpenDiscoveryModal = () => {
        setMenuAnchorEl(null)
        setDiscoverModal(true)
    }

    const handleClick = (event) => dataset.length 
            ? setMenuAnchorEl(event.currentTarget) 
            : handleOpenDiscoveryModal()

    const handleCloseDiscoverPopup = () => setDiscoverModal(false)

    const handleClose = () => setMenuAnchorEl(null)
    
    const handleOpenDataTable = (e) => {
        e.stopPropagation()
        setAnchorEl(null)
        setOpenDataTable(true)
    }

    const handleCloseDataTable = () => setOpenDataTable(false)

    const menuItems = () => (
        <div>
            <MenuItem onClick={handleOpenDataTable}>
                <InfoOutlined fontSize="small" style={{marginRight: '10px'}}/> Info
            </MenuItem>
            <MenuItem onClick={handleOpenKpiEditor}>
                <SignalCellularAltTwoTone fontSize="small" style={{marginRight: '10px'}}/>Deep Granularity
            </MenuItem>
            <MenuItem onClick={handleRemoveData}>
                <DeleteOutlined fontSize="small" style={{marginRight: '10px'}}/>Remove
            </MenuItem>
        </div>
    )

    const addDatasetMsg = <div className="addData"><Add style={{ width: "15px" }}/> Add Alternative KPI </div>

    const afterPickData = (
        <div className="selectedData">
            <div className="selectedData__info">
                <p className="smallFont">{dataset[index]?.datasetName}</p>
                <p className="selectedData__color" style={{color: kpi_unselected ? colors.textSecondary : ''}}>{dataset[index]?.columnName}</p>
            </div>
            <div>
                <MenuBar setAnchorEl={setAnchorEl} anchorEl={anchorEl} menuId={dataset[index]?.value}>
                    {menuItems()}
                </MenuBar>
            </div>
        </div>        
    )

    const dataTable = (
        <ContainerDataTable 
        dataset={currentDataset} 
        ticker={ticker} 
        handleClose={handleCloseDataTable} 
        open={openDataTable}
        />
    )

    return (
        <ThemeProvider theme={{dropdownColor: datasetColors[index], done: (currentDataset?.datasetValue)}}>
            <DropDown.DatasetButton disabled={inactive} onClick={(isKpiOpen && dataset[index]) ? handleOpenKpiEditor : handleClick} isCurrent={kpiEditorIndex === index}>
                { dataset[index] ? afterPickData : addDatasetMsg }
            </DropDown.DatasetButton>
            <PopoverMenu
                anchorEl={menuAnchorEl}
                onClose={handleClose}>
                <DatasetDropdown close={handleClose} currentDataset={currentDataset} columns={columns} {...datasetProps} handleOpenDiscovery={handleOpenDiscoveryModal}/>
            </PopoverMenu>
            { openDataTable && dataTable }
            <DiscoverModal key={`discover-modal-${index}`} open={discoverModal} handleClose={handleCloseDiscoverPopup} dataset={dataset}/>
        </ThemeProvider>
    )
}
